<template>
  <div style="height: 100%">
    <div class="columns fastAnimation" v-if="step === STEPS.CALENDAR_LOADING">
      <div class="column">
        Chargements
      </div>
    </div>
    <div v-if="step === STEPS.CALENDAR_SELECT"
      class="fastAnimation columns is-column"
      style="height: 100%"
    >
      <div class="column is-narrow has-bg-light">
        Sélectionnez un calendrier
      </div>
      <div class="column is-narrow is-relative">
        <div class="box3-top"></div>
        <div class="control">
          <!--<div class="select">
            <select v-model="calendar" @change="calendarSelection">
              <option :value="null">Selectionner un calendrier</option>
              <option v-for="c in calendars" :value="c.id">{{c.summary}}</option>
            </select>
          </div>-->
        </div>

        <div v-for="c in calendars" class="field is-margin-top-small columns is-vcentered is-gapless">
          <div class="column is-narrow is-padding-left-small">
            <input :id="c.id" @change="calendarSelection" :value="c.id" v-model="calendar" type="radio" name="calendrier" class="switch is-rounded is-success is-medium"> <label :for="c.id"><b class="is-size-5 has-text-grey">{{c.summary}}</b></label>
          </div>
          <!-- <div class="column is-narrow">
            <input v-model="calendar"
                 :id="c.id"
                 type="radio"
                 :value="c.id"
                 name="calendrier"
                 @change="calendarSelection"
                 class="switch is-rounded is-medium"><label :for="c.id"></label>
          </div>
          <div class="column"><label :for="c.id" class=""><b class="is-size-5 has-text-grey">{{c.summary}}</b></label></div> -->
        </div>
      </div>
      <div class="column columns is-vcentered"
        style="flex: 1 1 auto"
      >
        <div class="column has-text-centered">
          <span class="icon is-size-3 has-text-grey2"><i class="fas fa-3x fa-bars"></i></span>
        </div>
      </div>
    </div>
    <div class="columns is-gapless is-multiline" v-if="step === STEPS.EVENT_SELECT">
      <div
        v-if="events.length > 2500"
        class="column is-12 is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right has-bg-danger">
        <span class="has-text-white is-size-6"><b>Attention plus de 2500 événements à importer !</b></span>
      </div>
      <!--<div class="column is-2 has-cursor-pointer columns is-vcentered is-gapless has-text-centered">
        <span class="column is-self-centered has-text-grey is-size-4 icon is-medium"><i class="far fa-arrow-to-left fa-lg"></i></span>
      </div>
      <div class="column is-10">
        <div class="field">
          <div class="control" id="filtername">
            <input type="text" class="input" v-model="search"
                   placeholder="Rechercher un évènement"
                   :class="{'is-degrad-info has-text-white':search && search.length}">
          </div>
        </div>
      </div>-->
      <div class="column is-12">
        <div class="field has-addons is-border-bottom">
          <p class="control">
            <a class="button is-grey is-inverted is-medium is-square is-borderless"
               @click="step = STEPS.CALENDAR_SELECT, calendar = null">
              <span class="icon"><i class="far fa-arrow-to-left"></i></span>
            </a>
          </p>
          <p class="control has-icons-right is-expanded is-border-left is-padding-right quickview-filterClassique">
            <input class="input is-fullwidth is-medium is-borderless"
                   type="text"
                   v-model="search"
                   placeholder="Rechercher un évènement">
            <span class="icon is-right" style="z-index:4 !important">
              <i class="fal fa-search fa-lg"></i>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-paddingless inner-scroll liste-users is-12">
        <ul>
          <li class="columns is-vcentered column is-paddingless is-border-bottom" v-for="(e, i) in events"
              :key="i">
            <!--<div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
              <span class="avatar" :class="'avatar-0' + ((i % 6) + 1)">
               <span class="">
                 <i class="fal fa-calendar-alt"></i>
               </span>
              </span>
            </div>-->
            <div
              class="column is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-right is-size-5 is-overflow-hidden is-nowrap hover-degrad">
              <span v-if="e.summary">{{e.summary}}</span>
              <i v-else class="is-size-6">Evènement sans titre !</i>
              <br>
              <span class="has-text-grey is-size-6">{{e.prettyDate}}</span>&nbsp;
            </div>
            <div class="column is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall">
              <a v-if="googleRdvsId.includes(e.id)" disabled="disabled" class="button is-circle is-primary">
                <span class="icon is-small"><i class="fal fa-save"></i></span>
              </a>
              <a @click="selectEvent(null)" v-else-if="event && event.id === e.id" class="button is-circle is-success">
                <span class="icon is-small"><i class="fas fa-check"></i></span>
              </a>
              <a @click="selectEvent(e)" v-else class="button is-circle is-light">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="columns is-multiline fastAnimation" v-if="step === STEPS.CONTACT_SELECT">
      <div class="column is-12">
        <label for="" class="label">Contact *</label>
        <multiselect v-model="contact" :custom-label="contactName" track-by="pk" :placeholder="''"
                     :options="contacts" :searchable="true" :close-on-select="true" :show-labels="false"
                     class="multiselect--option-ico"
                     @search-change="loadContacts">
          <span slot="placeholder" class="multiselect__placeholder">Sélectionnez un contact</span>
          <span slot="noOptions">La liste est vide</span>
        </multiselect>
      </div>
      <div class="column is-12">
        <div class="control">
          <label class="label">Type de RDV *</label>
          <div class="select">
            <select name="rdv-type" id="rdv-type" v-model="rdv_type"
                    :class="{'is-danger': errors.has('rdv-type')}"
                    v-validate="'required'" data-vv-as="Type du RDV" required>
              <option :value="null">Type du Rendez-vous</option>
              <option value="R0">R0</option>
              <option value="R1">R1</option>
              <option value="R2">R2</option>
              <option value="R3">R3</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <span v-if='isCalendarSelect'></span>
  </div>
</template>

<script>
  import { isNil, isPlainObject } from 'lodash'
  import moment from 'moment'
  import { mapGetters, mapState } from 'vuex'

  const STEPS = {
    CALENDAR_LOADING: 'CALENDAR_LOADING',
    CALENDAR_SELECT: 'CALENDAR_SELECT',
    EVENT_SELECT: 'EVENT_SELECT',
    CONTACT_SELECT: 'CONTACT_SELECT'
  }

  export default {
    name: 'GoogleEventSelection',
    props: {},
    components: {},
    data () {
      return {
        calendar: null,
        calendars: [],
        contacts: [],
        contact: null,
        rawEvents: [],
        event: null,
        search: null,
        step: STEPS.CALENDAR_LOADING,
        STEPS: STEPS,
        rdv_type: null
      }
    },
    computed: {
      ...mapGetters(['googleRdvs']),
      ...mapState(['currentUser']),
      googleRdvsId () {
        return this.googleRdvs.map(x => {
          return x.google_event_id
        })
      },
      isCalendarSelect () {
        let calendarIsSelected
        if (this.step === STEPS.CALENDAR_SELECT) {
          calendarIsSelected = true
        } else {
          calendarIsSelected = false
        }
        this.$emit('isCalendarSelect', calendarIsSelected)
        return calendarIsSelected
      },
      canSubmit () {
        if (this.step === STEPS.CALENDAR_LOADING) {
          return false
        }
        if (this.step === STEPS.CALENDAR_SELECT) {
          return isNil(this.calendar) === false
        }
        if (this.step === STEPS.EVENT_SELECT) {
          return isNil(this.event) === false
        }
        if (this.step === STEPS.CONTACT_SELECT) {
          return isNil(this.contact) === false && isNil(this.rdv_type) === false
        }
        return false
      },
      events () {
        let events = this.rawEvents.reverse().map(e => {
          if (e.start && e.start.dateTime) {
            e['prettyDate'] = moment(e.start.dateTime).format('DD/MM/YYYY HH:mm')
          } else {
            let d = moment(e.start.date, 'YYYY-MM-DD')
            e['prettyDate'] = d.format('DD/MM/YYYY')
          }
          return e
        })

        if (this.search && this.search.length > 2) {
          return events.filter(x => {
            return !isNil(x.summary) && x.summary.length
          }).filter(x => {
            let summary = x.summary.toLowerCase()
            return summary.includes(this.search.toLowerCase())
          })
        } else {
          return events
        }
      }
    },
    methods: {
      calendarSelection () {
        if (isNil(this.calendar) === false) {
          this.step = STEPS.EVENT_SELECT
          this.loadEvents()
        }
      },
      contactName (contact) {
        if (contact && contact.last_name) {
          return `${contact.last_name} ${contact.first_name}`
        }
      },
      loadCalendars () {
        window.gapi.client.calendar.calendarList.list({})
          .then((r) => {
            this.calendars = r.result.items.filter(x => x.accessRole !== 'reader')
            this.step = STEPS.CALENDAR_SELECT
          })
      },
      loadContacts (query = null) {
        if (isNil(query) && !isPlainObject(query)) {
          query = {}
        } else {
          query = {
            last_name: query
          }
        }
        query['sort'] = 'last_name:asc'
        this.$api.contactService.get(query).then(r => {
          this.contacts = r.data.items
        })
      },
      loadEvents () {
        this.isLoadingEvents = true
        window.gapi.client.calendar.events.list({
          'calendarId': this.calendar,
          'showDeleted': false,
          'singleEvents': true,
          'maxResults': 2500,
          'timeMin': moment().subtract(3, 'months').toDate().toISOString(),
          'timeMax': moment().add(3, 'months').toDate().toISOString(),
          'orderBy': 'startTime'
        }).then((r) => {
          this.rawEvents = r.result.items
          this.isLoadingEvents = false
        }).catch(err => {
          console.log(err)
        })
      },
      submit () {
        if (!this.canSubmit) {
          if (isNil(this.calendar)) {
            this.$notify({
              type: 'is-danger',
              text: 'Vous devez indiquer le calendrier à utiliser.'
            })
          } else if (isNil(this.event)) {
            this.$notify({
              type: 'is-danger',
              text: 'Vous devez indiquer l\'évènement à importer.'
            })
          } else if (isNil(this.contact)) {
            this.$notify({
              type: 'is-danger',
              text: 'Vous devez préciser le contact à associer à ce rendez-vous.'
            })
          } else if (isNil(this.rdv_type)) {
            this.$notify({
              type: 'is-danger',
              text: 'Vous devez préciser le type de rendez-vous.'
            })
          }
        } else {
          if (this.step === STEPS.CALENDAR_SELECT) {
            this.step = STEPS.EVENT_SELECT
            this.loadEvents()
          } else if (this.step === STEPS.EVENT_SELECT) {
            this.step = STEPS.CONTACT_SELECT
            this.loadContacts()
          } else if (this.step === STEPS.CONTACT_SELECT) {
            this.syncEvent()
          }
        }
      },
      selectEvent (event) {
        this.event = event
      },
      syncEvent () {
        let date
        let endDate
        if (this.event.start && this.event.start.dateTime) {
          date = moment(this.event.start.dateTime)
        } else {
          date = moment(this.event.start.date, 'YYYY-MM-DD')
        }
        if (this.event.end && this.event.end.dateTime) {
          endDate = moment(this.event.end.dateTime)
        } else {
          endDate = moment(this.event.end.date, 'YYYY-MM-DD')
        }
        if (!endDate) {
          endDate = moment(date).add(2, 'h')
        }
        let name = this.currentUser.first_name + ' ' + this.currentUser.last_name
        let rdv = {
          date: date.utc().format('DD/MM/YYYY HH:mm'),
          end_date: endDate.utc().format('DD/MM/YYYY HH:mm'),
          contact: this.contact,
          title: this.event.summary,
          note: this.event.description,
          rdv_type: this.rdv_type,
          google_calendar_id: this.calendar,
          google_event_id: this.event.id,
          exported_by_name: name,
          exported_by: this.currentUser.pk
        }
        console.log(rdv)
        this.$api.rdvService.post(rdv)
          .then(res => {
            this.$notify({
              type: 'is-success',
              text: 'Évènement importé.'
            })
            console.log(res.data)
            this.$emit('submit', {rdv: res.data})
          })
          .catch(err => {
            console.log(err)
            this.$notify({
              type: 'is-danger',
              text: 'Impossible d\'ajouter ce rendez-vous à votre calendrier'
            })
          })
      }
    },
    created () {
      this.loadCalendars()
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/quickview/GoogleEventSelection.vue